import React from 'react';
import { Tab, TabWrapper } from './styled';
import { AGENTS, CLOUD_AGENTS, RUN_STATUS_LOG } from './constants';

const Tabs = ({ onToggleAgents, selectedTab, setSelectedTab }) => {
  return (
    <TabWrapper>
      <Tab isActive={ selectedTab === AGENTS } onClick={ () => setSelectedTab(AGENTS) }>Runners</Tab>
      <Tab isActive={ selectedTab === CLOUD_AGENTS } onClick={ () => onToggleAgents() } >Security Scanners</Tab>
      <Tab isActive={ selectedTab === RUN_STATUS_LOG } onClick={ () => setSelectedTab(RUN_STATUS_LOG) }>Run Status Log</Tab>
    </TabWrapper>
  );
};

export default Tabs;
